import { ShopMarketplaceButtons } from '~/components/ShopMarketplaceButtons'

export const LootboxNotFound = () => {
    return (
        <div className='flex flex-col items-center gap-8 font-black w-max mx-auto text-center py-12'>
            <div className='text-xl md:text-4xl'>
                WE CAN'T FIND ANY
                <br /> LOOT BOXES IN YOUR WALLET
            </div>
            <ShopMarketplaceButtons />
        </div>
    )
}
